import script from "./TakeNote.vue?vue&type=script&setup=true&lang=js"
export * from "./TakeNote.vue?vue&type=script&setup=true&lang=js"

import "./TakeNote.vue?vue&type=style&index=0&id=4a016c38&lang=css"

const __exports__ = script;

export default __exports__